import React, {Component} from 'react'
import {
    Typography,
} from '@material-ui/core'

export default class Tally extends Component {
    render() {
        const {show, votes} = this.props;
        if (!show) {
            return null
        }
        let dopes = 0
        let nahs = 0
        if (votes) {
            const totalVotes =
                votes.dopeVotes + votes.nahVotes
            const onePercent = totalVotes / 100
            dopes = Math.round(votes.dopeVotes / onePercent)
            nahs = Math.round(votes.nahVotes / onePercent)
        }
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                height: 80,
                width: 280,
                backgroundColor: 'rgba(0,0,0,0.8)',
                alignItems: 'center',
                justifyContent: 'space-around',
                position: 'absolute',
                top: 100,
                left: 0
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    // marginLeft:10
                }}>
                    <Typography style={{fontSize: 20, color: '#c9081d', fontWeight: 'bold'}}>Nahs</Typography>
                    <Typography style={{fontSize: 30, color: '#c9081d', fontWeight: 'bold'}}>{nahs}%</Typography>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    // marginRight:10
                }}>
                    <Typography style={{fontSize: 20, color: '#7dc741', fontWeight: 'bold'}}>Dopes</Typography>
                    <Typography style={{fontSize: 30, color: '#7dc741', fontWeight: 'bold'}}>{dopes}%</Typography>
                </div>
            </div>
        )
    }
}